import React, { useState, useEffect } from 'react';

let setModalState = null;

// Funciones globales expuestas mediante promesas
window.nexusAlert = (message, type = 'info') => {
    return new Promise((resolve) => {
        if (setModalState) {
            setModalState({ type: 'alert', message, resolve, alertType: type });
        } else {
            console.warn("NexusModals no montado. Fallback a window.alert().");
            window.alert(message);
            resolve();
        }
    });
};

window.nexusConfirm = (message) => {
    return new Promise((resolve) => {
        if (setModalState) {
            setModalState({ type: 'confirm', message, resolve });
        } else {
            console.warn("NexusModals no montado. Fallback a confirm().");
            resolve(window.confirm(message));
        }
    });
};

window.nexusPrompt = (message, defaultValue = '') => {
    return new Promise((resolve) => {
        if (setModalState) {
            setModalState({ type: 'prompt', message, defaultValue, resolve });
        } else {
            console.warn("NexusModals no montado. Fallback a prompt().");
            resolve(window.prompt(message, defaultValue));
        }
    });
};

const NexusModals = () => {
    const [modal, setModal] = useState(null);
    const [promptValue, setPromptValue] = useState('');

    useEffect(() => {
        setModalState = setModal;
        return () => { setModalState = null; };
    }, []);

    useEffect(() => {
        if (modal && modal.type === 'prompt') {
            setPromptValue(modal.defaultValue || '');
        }
    }, [modal]);

    if (!modal) return null;

    const handleConfirm = () => {
        if (modal.type === 'prompt') modal.resolve(promptValue);
        else modal.resolve(true);
        setModal(null);
    };

    const handleCancel = () => {
        if (modal.type === 'prompt') modal.resolve(null);
        else modal.resolve(false);
        setModal(null);
    };

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(15, 23, 42, 0.7)', backdropFilter: 'blur(5px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 999999, animation: 'fadeIn 0.2s ease', fontFamily: "'Inter', sans-serif"
        }}>
            <div style={{
                background: '#1E293B', width: '90%', maxWidth: '520px',
                borderRadius: '16px', padding: '30px', color: 'white',
                boxShadow: '0 20px 40px rgba(0,0,0,0.5)', border: '1px solid rgba(255,255,255,0.1)',
                maxHeight: '85vh', overflowY: 'auto'
            }}>
                <h3 style={{ margin: '0 0 15px 0', fontSize: '1.25rem', color: '#F8FAFC', fontWeight: 'bold' }}>
                    {modal.type === 'alert' ? 'Aviso' : modal.type === 'prompt' ? 'Ingresar Dato' : 'Confirmación'}
                </h3>

                <p style={{
                    color: '#cbd5e1',
                    fontSize: '0.95rem',
                    marginBottom: 25,
                    lineHeight: 1.55,
                    whiteSpace: 'pre-line',
                    wordBreak: 'break-word'
                }}>
                    {modal.message}
                </p>

                {modal.type === 'prompt' && (
                    <input
                        type="text"
                        value={promptValue}
                        onChange={e => setPromptValue(e.target.value)}
                        placeholder="Escribe aquí..."
                        autoFocus
                        style={{
                            width: '100%', padding: '12px 15px', borderRadius: '8px',
                            background: '#0F172A', border: '1px solid rgba(255,255,255,0.1)',
                            color: 'white', marginBottom: 20, boxSizing: 'border-box'
                        }}
                        onKeyDown={e => e.key === 'Enter' && handleConfirm()}
                    />
                )}

                <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
                    {modal.type !== 'alert' && (
                        <button onClick={handleCancel} style={{
                            padding: '10px 20px', borderRadius: '8px', cursor: 'pointer',
                            background: 'transparent', color: '#94A3B8', border: 'none', fontWeight: 'bold'
                        }}>
                            Cancelar
                        </button>
                    )}
                    <button onClick={handleConfirm} style={{
                        padding: '10px 20px', borderRadius: '8px', cursor: 'pointer',
                        background: '#FF3364', color: 'white', border: 'none', fontWeight: 'bold',
                        boxShadow: '0 4px 15px rgba(255, 51, 100, 0.3)'
                    }}>
                        Aceptar
                    </button>
                </div>
            </div>
            <style>{`@keyframes fadeIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }`}</style>
        </div>
    );
};

export default NexusModals;
